module.exports = __webpack_public_path__ + "static/media/midrive_logo_white.8d0dfa6a.png";